export const Networking = [
  {
    path: '/networking/:app_module_id',
    name: 'networking.index',
    component: () => import('@/pages/Networking/NetworkingModule')
  },
  {
    path: '/networking/meets/index',
    name: 'networking.meets',
    component: () => import('@/pages/Networking/NetworkingMeets')
  },
  {
    path: '/networking/:app_module_id/all',
    name: 'networking.all',
    component: () => import('@/pages/Networking/NetworkingPage'),
    meta: {
      title: 'All Networkers'
    }
  },
  {
    path: '/networking/:app_module_id/new',
    name: 'networking.new',
    component: () => import('@/pages/Networking/NetworkingPage'),
    meta: {
      title: 'New Networkers'
    }
  },
  {
    path: '/networking/:app_module_id/liked',
    name: 'networking.liked',
    component: () => import('@/pages/Networking/NetworkingPage'),
    meta: {
      title: 'Shortlisted'
    }
  },
  {
    path: '/networking/:app_module_id/skipped',
    name: 'networking.skipped',
    component: () => import('@/pages/Networking/NetworkingPage'),
    meta: {
      title: 'Skipped'
    }
  },
  {
    path: '/networking/:app_module_id/contacted',
    name: 'networking.contacted',
    component: () => import('@/pages/Networking/NetworkingPage'),
    meta: {
      title: 'Contacted'
    }
  },
  {
    path: '/networking/:app_module_id/connected',
    name: 'networking.connected',
    component: () => import('@/pages/Networking/NetworkingPage'),
    meta: {
      title: 'Connected'
    }
  },
  {
    path: '/networking/:app_module_id/speed-networking',
    name: 'networking.speed',
    component: () => import('@/pages/Networking/NetworkingSpeed')
  },
  {
    path: '/networking/:app_module_id/group-networking',
    name: 'networking.group',
    component: () => import('@/pages/Networking/NetworkingGroup')
  },
  {
    path: '/networking/:app_module_id/speed-networking/history',
    name: 'networking.speed.history',
    component: () => import('@/pages/Networking/NetworkingHistory')
  },
  {
    path: '/networking/:app_module_id/group-networking/history',
    name: 'networking.group.history',
    component: () => import('@/pages/Networking/NetworkingGroupHistory')
  }
]
